import {Button, DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog, Typography} from "@mui/joy";
import {useSessionCookie} from "../hooks/useSessionCookie";
import React, {useEffect, useState} from "react";
import {TestInfoStep} from "../pages/Register";
import {User, UserFormData} from "../models/user";
import {useAsync} from "../hooks/useAsyncResult";
import {updateProfile} from "../services/api/user";
import {useFeedback} from "../hooks/useFeedback";
import getUpdatedFields from "../utils/getUpdatedFields";
import {useTranslation} from "react-i18next";

type LanguageTestSetupDialogProps = {
    onClose?: () => void
}

const LanguageTestSetupDialog = (props: LanguageTestSetupDialogProps) => {
    const feedback = useFeedback()
    const {t} = useTranslation()
    const {userSession, setUserSession} = useSessionCookie()
    const [languageSetupDialogVisible, setLanguageSetupDialogVisible] = useState(false)
    const [userFormData, setUserFormData] = useState<User>(userSession['currentUser'])
    const updateProfileAsyncResult = useAsync(updateProfile, true, true, false)

    const handleFormDataChange = (key: keyof UserFormData, value: any) => {
        setUserFormData({...userFormData, [key]: value})
    }

    const handleUpdateSuccess = () => {
        feedback.showFeedback("accountUpdateSuccessMessage", "success")
        setLanguageSetupDialogVisible(false)
        setUserSession({
            currentUser: {
                ...updateProfileAsyncResult.payload
            },
            token: userSession.token,
            expiresAt: userSession.expiresAt,
            merchantStore: userSession.merchantStore,
        }, new Date(userSession.expiresAt))
    }

    const handleUpdate = () => {
        const updatedFields: UserFormData = getUpdatedFields(userSession['currentUser'], userFormData)
        updateProfileAsyncResult?.execute(updatedFields)
    }

    useEffect(() => {
        if (updateProfileAsyncResult.isSuccess)
            handleUpdateSuccess()
    }, [updateProfileAsyncResult.isSuccess])


    useEffect(() => {
        const currentUser = userSession?.['currentUser'];
        if (!currentUser?.targetScore || !currentUser?.preferredExam) {
            setLanguageSetupDialogVisible(true)
        }

    }, [userSession])

    return <Modal open={languageSetupDialogVisible} onClose={(event, reason) => {
        if (reason === "backdropClick")
            return
        setLanguageSetupDialogVisible(false)
        props.onClose?.()
    }}>
        <ModalDialog variant="outlined" role="alertdialog"
                     sx={{overflowY: "auto", minWidth: {xs: "100%", md: "40rem"}}}>

            <DialogTitle sx={{alignItems: "center"}}>
                <Typography level={"h3"} textAlign={"center"} sx={{width: "100%"}}>
                    {t("languageTestSetupTitle")}
                </Typography>
            </DialogTitle>

            <Divider/>

            <Typography level={"body-lg"}>
                {t("languageTestSetupDescription")}
            </Typography>

            <TestInfoStep userFormData={userFormData} onFormDataChange={handleFormDataChange}/>

            <DialogActions>
                <Button loading={updateProfileAsyncResult.loading} onClick={handleUpdate}
                        disabled={!userFormData?.preferredExam || !userFormData?.targetScore}>
                    {t("languageTestSetupActionLabel")}
                </Button>
            </DialogActions>
        </ModalDialog>
    </Modal>
}

export default LanguageTestSetupDialog